/*
 * @Author: zxf
 * @Date: 2021-11-18 16:13:44
 * @LastEditors: zxf
 * @LastEditTime: 2021-11-19 14:10:57
 * @Description: file content
 * @FilePath: \neolix-map-sdk\src\utils\ObjectEditController.js
 */
import Controller from '../clazz/Controller';
/**
 * 获取对象编辑控制器的函数
 * 单例对象
 */
export class ObjectEditController extends Controller {
    /**
     * 构造函数
     * @param  {object} options 可选对象
     * @return {undefined}
     */
    constructor(options) {
        super(options);

        this.data = null;
        this.originalData = null;
        /** *
         * 为了进行批量编辑而添加的属性字段，保存批量编辑返回的原始数据
         * @type {Array}
         */
        this.datas = [];
    }

    /**
     * 设置编辑对象
     * @param  {object} data 编辑对象
     * @return {undefined}
     */
    setData(data) {
        this.data = data;
    }

    /**
     * 批量编辑：设置要批量编辑的数据
     * @param  {object} dataArray 编辑对象
     * @param  {boolean} batchType 批量操作类型
     * @return {undefined}
     */
    setBatchData(dataArray, batchType, options) {
        this.clear();

        if (dataArray.length === 0) {
            return;
        }
        const factory = FeatureFactory.getInstance();
        dataArray.forEach(data => {
            // 如果进来直接是数据模型，直接压到datas属性中
            if (data instanceof navinfo.framework.data.DataModel) {
                data.setOptions({
                    boolBatch: true,
                    batchType: batchType
                });
                this.datas.push(data);
            } else {
                this.datas.push(factory.create(data, {
                    boolBatch: true,
                    batchType: batchType,
                    objName: data.objName,
                    objMeta: data.objMeta,
                    objVersion: data.objVersion
                }));
            }
        });
        let currentData = null;
        if (dataArray[0] instanceof navinfo.framework.data.DataModel) {
            dataArray[0].setOptions({
                boolBatch: true,
                batchType: batchType,
                extends: options || null
            });
            currentData = dataArray[0];
        } else {
            currentData = factory.create(dataArray[0], {
                boolBatch: true,
                batchType: batchType,
                objName: dataArray[0].objName,
                objMeta: dataArray[0].objMeta,
                objVersion: dataArray[0].objVersion,
                extends: options || null
            });
        }
        for (let i = 0; i < this.datas.length; i++) {
            currentData.merge(this.datas[i]);
        }
        for (let i = 0; i < this.datas.length; i++) {
            this.datas[i].clean(currentData);
        }
        // 数据做过merge和clean之后，为了保证后续差分、更新的准确性，要重置一下原始Json数据
        // 使用hard参数将origin对象的属性值更新为与当前对象的属性值一致，主要用于处理批量比较后属性值不一致而赋的undefined的属性
        currentData.resetOrigin(true);

        this.setData(currentData, 'Feature', options);
    }
}
